
export const HOST = 'https://video.avkchina.cn';
// export const HOST = process.env.NODE_ENV === 'production'?'http://shiping.jiluoing.com':'/shipin';